/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
import axios from 'axios';

import "./topBox.css"

const apiurl = `${process.env.REACT_APP_API}`;
const imgurl = `${process.env.REACT_APP_URL}/image/products`

function numberWithCommas (nStr) {
    nStr += '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
};

const TopBox = () => {
  const [dailyChart, setDailyChart] = useState([]);
  const [reporttype, setReportType] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchOrderChart = async () => {
    setLoading(true);
    // setReportType(period);
    try {
        const response = await axios.get(`${apiurl}/reports.php?period=monthlyproducts`);
        // console.log(response);
        if(response.data.message==="OK") {
            setDailyChart(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrderChart();
  },[]);

  // console.log(dailyChart);

  return (
    <div className="topBox">
      <h1>Top 10 Products</h1>
      {loading ? (
                <p>Loading...</p>
            ) : (
      <div className="list">
        {dailyChart.map(dc=>(
          <div className="listItem" key={dc.prodName}>
            <div className="user">
              <img src={`${imgurl}/${dc.img}`} alt="" />
              <div className="userTexts">
                <span className="name">{dc.prodName}</span>
                {/* <span className="id">{dc.id}</span> */}
              </div>
            </div>
            <span className="amount">{numberWithCommas(dc.amount)}</span>
          </div>
        ))}
      </div>
      )}
    </div>
  )
}

export default TopBox